import { IErrorBaseProps } from '../components/itemsError/ItemError';
import { ControlFacet } from '../models/controls/ControlFacet';
import { defaultRenderComponentOption } from '../components/controls/defaultRenderComponentControlOption';

/**
 * @public
 */
export interface IItemErrorControlProps {
    itemKey: string;
    error: Error;
}

/**
 * @public
 */
export interface IItemErrorControlOverrides {
    errorRenderer: React.ComponentType<IErrorBaseProps>;
}

/**
 * @public
 */
export const itemErrorControl: ControlFacet<IItemErrorControlProps, IItemErrorControlOverrides> = new ControlFacet('itemErrorControl', {
    errorRenderer: defaultRenderComponentOption<IErrorBaseProps>()
});
